export default "__VITE_ASSET__My0IJVLB__"